@if (display(); as display) {
  <div
    class="flex rounded-full p-1 text-white"
    [ngClass]="display.cssClass"
    [matTooltip]="display.tooltip"
  >
    <mat-icon class="icon-sm">{{ display.icon }}</mat-icon>
  </div>
}
